import { makeAutoObservable, runInAction } from 'mobx';
import { getAPIUrl } from '../../api/apiUtils';
import { apiFetch } from "../../api/apiClient";

class AllCommunitiesAverageStore {
  data = [];
  loading = false;
  error = null;
  startDate = '';
  endDate = '';
  selectedGroupIds = [];
  cache = {};
  aggregation = 'day';

  constructor() {
    makeAutoObservable(this);
  }

  setFilters({ startDate, endDate, selectedGroupIds, aggregation = 'day' }) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.selectedGroupIds = selectedGroupIds;
    this.aggregation = aggregation;
  }

  // Ключ кэша по фильтрам
  getCacheKey(filters) {
    return JSON.stringify(filters);
  }

  async fetchData() {
    runInAction(() => {
      this.loading = true;
      this.error = null;
    });
    try {
      if (!this.startDate || !this.endDate || this.selectedGroupIds.length === 0) {
        runInAction(() => {
          this.data = [];
          this.loading = false;
        });
        return;
      }
      const filters = {
        startDate: this.startDate,
        endDate: this.endDate,
        selectedGroupIds: this.selectedGroupIds,
        aggregation: this.aggregation
      };
      const cacheKey = this.getCacheKey(filters);
      if (this.cache[cacheKey]) {
        this.data = this.cache[cacheKey];
        this.loading = false;
        return;
      }
      const params = {
        community_id: this.selectedGroupIds.join(','),
        start_date: this.startDate,
        end_date: this.endDate,
        period: this.aggregation
      };
      const url = `${getAPIUrl()}/detection/activity_log_aggregated`;
      const response = await apiFetch(url + '?' + new URLSearchParams(params));
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      runInAction(() => {
        this.data = Array.isArray(result.data) ? result.data : [];
        this.cache[cacheKey] = this.data;
      });
    } catch (e) {
      runInAction(() => {
        this.error = e;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  // Получение данных, сгруппированных по сообществам
  get dataByCommunity() {
    if (!this.data || this.data.length === 0) return {};
    
    const grouped = {};
    this.data.forEach(item => {
      const communityId = item.public_id;
      if (!grouped[communityId]) {
        grouped[communityId] = [];
      }
      grouped[communityId].push(item);
    });
    
    return grouped;
  }

  // Получение всех уникальных дат
  get allDates() {
    if (!this.data || this.data.length === 0) return [];
    
    const dates = new Set();
    this.data.forEach(item => {
      dates.add(item.time);
    });
    
    return Array.from(dates).sort((a, b) => new Date(a) - new Date(b));
  }
}

export const allCommunitiesAverageStore = new AllCommunitiesAverageStore();
